import { EventEmitter } from './EventEmitter';
export const FieldDidResetEvent = 'FIELD_DID_RESET_EVENT';
export function withFieldDidResetEventEmitter(Base) {
    return class ResetFieldEvenEmitter extends Base {
        constructor() {
            super(...arguments);
            this.fieldDidResetEventEmitter = new EventEmitter();
        }
        emitFieldDidResetEvent(field) {
            return this.fieldDidResetEventEmitter.emit(FieldDidResetEvent, field);
        }
        addFieldDidResetEventListener(listener) {
            this.fieldDidResetEventEmitter.addListener(FieldDidResetEvent, listener);
        }
        removeFieldDidResetEventListener(listener) {
            this.fieldDidResetEventEmitter.removeListener(FieldDidResetEvent, listener);
        }
    };
}
